module.exports = __webpack_public_path__ + "static/media/empty-modules.4c83fe56.svg";